import styled from 'styled-components';
export const RenderTarget = styled.div `
  width: 100%;
  height: 100%;
  position: relative;

  & > canvas {
    touch-action: none;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
export const Canvas2D = styled.canvas `
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
`;
